import i18next from "i18next";

import Booleanize from "utils/Booleanize";
import { initReactI18next } from "react-i18next";
import translationEN from "./translation.en.json";
import { getEnvs } from "state/EnvironmentsContext/EnvContext";
i18next.use(initReactI18next).init({
  lng: "en",
  preload: ["en"],
  debug: Booleanize(getEnvs((state) => state.isDevelopment)),
  resources: {
    en: {
      translation: translationEN,
    },
  },
});
